"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsAccessDenied = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _material = require("@mui/material");
var _Lock = _interopRequireDefault(require("@mui/icons-material/Lock"));
var _Home = _interopRequireDefault(require("@mui/icons-material/Home"));
var _react2 = require("@emotion/react");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
const shake = (0, _react2.keyframes)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    0%, 100% {\n        transform: rotate(0deg);\n    }\n    25% {\n        transform: rotate(-10deg);\n    }\n    75% {\n        transform: rotate(10deg);\n    }\n"])));

/**
 * A component that displays an "Access Denied" message for 403 errors.
 * Used when a user tries to access a resource they don't have permission for.
 * @component
 * @param {Object} props - Component props
 * @param {string} [props.message] - Optional custom message to display
 * @example
 * return (
 *   <DmsAccessDenied />
 * )
 * @example
 * return (
 *   <DmsAccessDenied message="You need admin permissions to access this page" />
 * )
 */
const DmsAccessDenied = _ref => {
  let {
    message
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    textAlign: "center",
    mt: 4
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    component: _Lock.default,
    sx: {
      fontSize: 80,
      mb: 2,
      color: 'warning.main',
      animation: "".concat(shake, " 0.5s ease-in-out infinite")
    }
  }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h1",
    gutterBottom: true
  }, _reactIntlUniversal.default.get("403Error").d("403 - Access Denied")), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h4",
    gutterBottom: true
  }, _reactIntlUniversal.default.get("AccessDenied").d("You don't have permission to access this resource")), message && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body1",
    color: "text.secondary",
    sx: {
      mb: 3
    }
  }, message), /*#__PURE__*/_react.default.createElement(_material.Button, {
    variant: "contained",
    color: "primary",
    startIcon: /*#__PURE__*/_react.default.createElement(_Home.default, null),
    component: _reactRouterDom.Link,
    to: "/"
  }, _reactIntlUniversal.default.get("GoHome").d("Go Home")));
};
exports.DmsAccessDenied = DmsAccessDenied;